import { getPaymentLink, Result } from '@uchi/payment-link';
import { IS_DEV, UCHIRU_LINK } from 'shared/constants';

export type Price = Pick<Result, 'price' | 'paymentPath'>;

export const fetchPriceData = async (productName: string, testPrice?: number): Promise<Price> => {
  if (IS_DEV) {
    return Promise.resolve({
      price: testPrice || null,
      paymentPath: '#',
    });
  }

  return getPaymentLink(productName, {
    customHost: UCHIRU_LINK,
  });
};
